module.exports = __webpack_public_path__ + "media/images/bg_2-b14a956bda06f2e9860bbe4625b7f738.jpg";